import { Space, Tabs } from "antd";
import { observer } from "mobx-react-lite";
import ordersStorage from "../../storages/orders.storage";
import { useEffect } from "react";
import Templates from "./tabs/templates";
import PartTypes from "./tabs/part-types";
import Parts from "./tabs/parts";

/* eslint-disable-next-line */
export interface SettingsPageProps {}

export interface IPartsFilter {
  category: string;
  part: string;
}

export function SettingsPage(props: SettingsPageProps) {
  const { loadOrders } = ordersStorage;

  useEffect(() => {
    loadOrders()
  }, [])

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <div>
        <Tabs defaultActiveKey="2">
          <Tabs.TabPane tab="Part Types" key="2">
            <PartTypes />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Parts" key="1">
            <Parts />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Templates" key="3">
            <Templates />
          </Tabs.TabPane>
        </Tabs>
      </div>

    </Space>
  );
}

export default observer(SettingsPage);
